module.exports = __webpack_public_path__ + "static/img/shiminyuanjing.8d58775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/shiminyuanjing.png
// module id = r9AX
// module chunks = 0